import { ContentfulData } from '../contentful/models/types';

// TODO(EHYBRID-895) - Address all typing changes that need to be improved
export type Serializable = any;

export type PercentToggle<T> = {
  value: T;
  percent: number;
};

export enum ToggleType {
  ROUTING = 'routing',
  DEFAULT = 'default',
}

export type RoutingToggles<T> = PercentToggle<T>[];

export type AnyToggleValue = ToggleValue<Serializable>;

export type TogglesMap<T> = Record<string, ToggleValue<T>>;

export interface ContentfulFeatureToggle<T> extends ContentfulData {
  fields: {
    hybridFeatureToggle_key: string;
    hybridFeatureToggle_enabled: boolean;
    hybridFeatureToggle_value: ToggleValue<T>;
  };
}

export type AnyContentfulFeatureToggle = ContentfulFeatureToggle<Serializable>;
